<template>
  <div
    class="time-box">
    <div
      class="content"
      :style="{justifyContent: current.showPropertiesHolder.textAlign}">
      <p
        :style="{color: contentColor, fontSize: current.showPropertiesHolder.fontSize}">
        {{timeStr}}
      </p>
    </div>
  </div>
</template>

<script>
  import current from "./mixin"
  import {formatDate, getweek} from "../../../../assets/js/Untis";
  export default {
    mixins: [current],
    name: "Time",
    data() {
      return {
        timer: null,
        timeStr: ''
      }
    },
    computed: {
      contentColor() {
        const contentColor = this.current.showPropertiesHolder.contentColor
        const parentContentColor = this.current.parent.styles.widget.colorInfo.contentColor
        return contentColor || parentContentColor
      },
    },
    created() {
      console.log('created',this.timeStr)
      this.actionFormatTime()
    },
    beforeDestroy() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    methods: {
      actionFormatTime() {
        if (this.current.showPropertiesHolder.dateFormatter === 'day') {
          this.timeStr = getweek(new Date())
        } else {
          this.timeStr =  formatDate(new Date().getTime())(this.current.showPropertiesHolder.dateFormatter)

          this.timer = setTimeout(() => {
            this.actionFormatTime()
          }, 1000)
        }
        console.log('this.timeStr',this.timeStr)
      },
      initChart() {

      },

      resize() {

      },
    }
  }
</script>

<style lang="less">

  .time-box {
    height: 100%;

    .content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        margin: 0;
      }
    }
  }
</style>
